import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { HistoryChatsService } from './historyChatsApi';
import { IHistoryChatListState } from '../../../../interfaces/history-chats/IHistoryChatsList';

const initialState: IHistoryChatListState = {
    chatIsLoading: false,
    chatsAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchHistoryChats = createAsyncThunk<any, undefined | null>(
    'historyChats/tryToFetchHistoryChats',
    async () => {
        const result = await HistoryChatsService.tryToFetchHistoryChats();
        return result?.data;
    }
);


export const historyChatsSlice = createSlice({
    name: 'historyChats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchHistoryChats
            .addCase(tryToFetchHistoryChats.pending, (state) => {
                state.chatsAreLoading = true;
            })
            .addCase(tryToFetchHistoryChats.rejected, (state) => {
                state.chatsAreLoading = false;
            })
            .addCase(tryToFetchHistoryChats.fulfilled, (state, action) => {
                state.chatsAreLoading = false;
                state.historyChats = action.payload;
            })

    },
});

export default historyChatsSlice.reducer;